'use client'

import { trackEvent } from '@lib/tracking'
import { TrackingEvents } from '@lib/tracking/TrackingEvents'
import { useEffect, useState } from 'react'
import CookiePolicyModal from './CookiePolicyModal'
import CookiesLink from './CookiesLink'
import { type FooterColorConfig } from './footerColors'

export default function CookiesLinkWithModalContainer({
  colorConfig,
}: {
  colorConfig: FooterColorConfig
}) {
  const [cookiePolicyModalVisible, setCookiePolicyModalVisible] =
    useState(false)

  const showCookiePolicyModal = () => {
    trackEvent(TrackingEvents.COOKIES_POLICY_MODAL_OPENED)
    setCookiePolicyModalVisible(true)
  }

  const hideCookiePolicyModal = () => {
    trackEvent(TrackingEvents.COOKIES_POLICY_MODAL_CLOSED)
    setCookiePolicyModalVisible(false)
  }

  useEffect(() => {
    const hash = window.location.hash
    if (hash === '#cookies') {
      showCookiePolicyModal()
    }
  }, [])

  return (
    <>
      <CookiesLink colorConfig={colorConfig} onClick={showCookiePolicyModal} />
      <CookiePolicyModal
        onClose={hideCookiePolicyModal}
        visible={cookiePolicyModalVisible}
      />
    </>
  )
}
